import { LayoutDashboard, Users, Images, Palette, CreditCard, LogOut, ExternalLink, ShieldCheck, Camera } from 'lucide-react';
import { Logo } from '../Logo';

export const NAV = [
  { id: 'overview', label: 'Overview', icon: LayoutDashboard },
  { id: 'attendees', label: 'Attendees', icon: Users },
  { id: 'photos', label: 'Photos', icon: Images },
  { id: 'photographers', label: 'Photographers', icon: Camera },
  { id: 'branding', label: 'Branding', icon: Palette },
  { id: 'billing', label: 'Billing', icon: CreditCard },
  { id: 'privacy', label: 'Privacy', icon: ShieldCheck },
];

export const Sidebar = ({ tab, onTab, tenant, account, onLogout }) => (
  <aside className="bg-surface border-b-2 lg:border-b-0 lg:border-r-2 border-line flex flex-col justify-between p-4 lg:w-64 lg:min-h-screen lg:sticky lg:top-0" data-testid="admin-sidebar">
    <div>
      <div className="px-2 py-2 mb-6 hidden lg:block">
        <Logo testId="sidebar-logo" />
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-3 truncate" data-testid="sidebar-tenant-name">{tenant?.name}</p>
      </div>
      <nav className="flex lg:flex-col gap-1 overflow-x-auto">
        {NAV.map(({ id, label, icon: Icon }) => {
          const active = tab === id;
          return (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => onTab(id)}
              className={`relative flex items-center gap-3 px-3 py-2.5 font-display font-semibold uppercase tracking-wider text-xs whitespace-nowrap border-2 transition-all ${
                active ? 'bg-cyan text-ink border-cyan shadow-sm' : 'text-slate-400 border-transparent hover:text-white hover:border-line'
              }`}
            >
              <Icon className="w-4 h-4" /> {label}
            </button>
          );
        })}
      </nav>
    </div>
    <div className="hidden lg:block space-y-3 pt-6 border-t-2 border-line mt-6">
      <a href={`/t/${tenant?.slug}`} target="_blank" rel="noreferrer" data-testid="sidebar-public-link" className="btn-ghost w-full !justify-start !text-[11px]">
        <ExternalLink className="w-3.5 h-3.5" /> Open public portal
      </a>
      <div className="flex items-center justify-between px-1">
        <div className="min-w-0">
          <p className="text-xs text-white font-semibold truncate">{account?.name}</p>
          <p className="font-mono text-[10px] text-slate-500 truncate">{account?.email}</p>
        </div>
        <button data-testid="logout-btn" onClick={onLogout} className="icon-btn" title="Log out"><LogOut className="w-4 h-4" /></button>
      </div>
    </div>
  </aside>
);
